import { apiService } from './apiService';

export const auditService = {
  // Get all audit logs
  async getLogs(params?: { 
    category?: string; 
    action?: string; 
    userId?: string;
    startDate?: string; 
    endDate?: string;
    page?: number;
    pageSize?: number;
  }) {
    const queryParams = new URLSearchParams();
    if (params?.category) queryParams.append('category', params.category);
    if (params?.action) queryParams.append('action', params.action);
    if (params?.userId) queryParams.append('userId', params.userId);
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);
    if (params?.page) queryParams.append('page', params.page.toString());
    if (params?.pageSize) queryParams.append('pageSize', params.pageSize.toString());
    
    const query = queryParams.toString();
    return await apiService.get(`/audit-logs${query ? `?${query}` : ''}`);
  },

  // Get audit log by ID
  async getLog(id: string | number) {
    return await apiService.get(`/audit-logs/${id}`);
  },

  async getByShipment(shipmentId: string | number, limit = 200) {
    return await apiService.get(`/audit-logs/shipment/${shipmentId}?limit=${limit}`);
  },

  async getByDriver(driverId: string | number, limit = 200) {
    return await apiService.get(`/audit-logs/driver/${driverId}?limit=${limit}`);
  },

  // Create audit log
  async createLog(data: any) {
    return await apiService.post('/audit-logs', data);
  },
};
